import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { useAuth, formatApiError } from "@/contexts/AuthContext";

export default function SignupPage() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/account" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await register(email, password, name);
      toast.success("Welcome to the maison.");
      navigate("/account");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const startGoogle = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="signup-page" className="bg-[#ffffff] min-h-screen flex items-center">
      <div className="max-w-[1200px] mx-auto w-full px-6 md:px-10 py-20 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <p className="overline">Create your account</p>
          <h1 className="font-serif text-5xl md:text-6xl leading-tight mt-3">
            Join the <span className="italic text-[#000000]">maison.</span>
          </h1>
          <p className="mt-5 text-[#000000]/70 leading-relaxed max-w-md">
            Register an account to track orders, save bespoke configurations
            and access the Trade-In programme.
          </p>
        </div>

        <div className="bg-[#f5f5f5] p-8 md:p-10">
          <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
            <input
              data-testid="signup-name"
              className="input-light bg-[#ffffff]"
              placeholder="Your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <input
              data-testid="signup-email"
              type="email"
              className="input-light bg-[#ffffff]"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              data-testid="signup-password"
              type="password"
              minLength={6}
              className="input-light bg-[#ffffff]"
              placeholder="Password (min 6 chars)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              data-testid="signup-submit"
              disabled={submitting}
              className="btn-primary w-full"
            >
              {submitting ? "Creating…" : "Create account"}
            </button>
          </form>

          <div className="flex items-center gap-3 my-6 text-[10px] tracking-[0.22em] uppercase text-[#000000]/40">
            <span className="flex-1 h-px bg-[#000000]/15" />
            or
            <span className="flex-1 h-px bg-[#000000]/15" />
          </div>

          <button
            data-testid="signup-google"
            onClick={startGoogle}
            className="btn-secondary-dark w-full"
          >
            Continue with Google
          </button>

          <p className="mt-8 text-sm text-[#000000]/65 text-center">
            Already a member?{" "}
            <Link
              to="/login"
              data-testid="link-to-login"
              className="text-[#000000] hover:underline"
            >
              Sign in
            </Link>
          </p>
        </div>
      </div>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}
